import {observer} from 'mobx-react';
import {Flow} from 'main/components';
import {withState, t} from 'shared/core';
import {InterviewScheduleEditFlowState} from '../state';
import steps from '../state/steps';
import Step from './steps';

const InterviewScheduleEditFlow = observer(({match, uiState}) => {
  return (
    <Flow
      name={uiState.interviewSchedule.templateName || t('recruiting.interview_schedules.edit.Untitled Interview Schedule')}
      backTitle={t('recruiting.interview_schedules.Interview Schedules')}
      backRoute='/interview-schedules'
      steps={steps}
      component={Step}
      uiState={uiState}
      baseUrl={`/interview-schedules/${match.params.id}/edit`}
      onStepSubmitted={step => uiState.onStepSubmitted(step)}
      onStepChanged={step => uiState.onStepChanged(step)}
    />
  );
});

export default withState(InterviewScheduleEditFlow, InterviewScheduleEditFlowState);
